<template>
  <b>
    <!-- { "address_id": 3, "member_id": 34, "first_name": "姜", "last_name": "坤", "street": "xxxxx", "apartment": "北七家镇东三旗村231", "city": "北京市", "state": "北京市", "zip_code": 10000, "country": "中国", "phone": "15910317397", "is_default": 1, "sort": 0 } -->
    <p class="shipping__address">
      <span class="shipping__client-name"
        >{{ address.first_name }} {{ address.last_name }}</span
      ><br />
      {{ address.street }} {{ address.apartment }}<br />
      {{ address.zip_code }}
      {{ address.city }},<br />{{ address.country }}
    </p>
    <p class="shipping__address">
      {{ address.phone }}
    </p>
  </b>
</template>

<script>
export default {
  name: 'UserShippingAddress',
  props: {address:""}
};
</script>
